module.exports = __webpack_public_path__ + "assets/stethoscope-pet.49ed17f4.svg";